module.exports = __webpack_public_path__ + "img/card25.40e6ab23.png";